module.exports = __webpack_public_path__ + "static/media/neutrals.653865f2.png";